/**
 * @file
 * Placeholder file for custom sub-theme behaviors.
 *
 */
(function($, Drupal) {
  /**
   * @type {{attach: Drupal.behaviors.pressReleaseList.attach}}
   */
  Drupal.behaviors.pressReleaseList = {
    attach : function() {
      var displaysBlock = $(".filter-press-release .display-block");
      var selectedYear = $(".filter-press-release .display-block:checked").val();

      function updateDisplay() {
        $(".press-release-accordion").addClass("hidden");
        $(".press-release-accordion[data-year='" + selectedYear + "']").removeClass("hidden");
      }

      updateDisplay();

      displaysBlock.click(function() {
        selectedYear = this.value;
        updateDisplay();
      });
    }
  };
})(jQuery, Drupal);
